module.exports = __webpack_public_path__ + "static/img/yx03.2b03ed8a.png";